enum PopupType {
    Advertising = 'advertising',
    Normal = 'normal',
}

export { PopupType };
